import { render, staticRenderFns } from "./FormAccess.vue?vue&type=template&id=6382e746&scoped=true"
import script from "./FormAccess.vue?vue&type=script&lang=js"
export * from "./FormAccess.vue?vue&type=script&lang=js"
import style0 from "./FormAccess.vue?vue&type=style&index=0&id=6382e746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382e746",
  null
  
)

export default component.exports